var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[_c('ReportTable',{attrs:{"fields":_vm.selectReportFields,"items":_vm.selectReportData,"isGrouped":_vm.selectIsGrouped}})],1):_c('div',[_c('div',{staticClass:"card"},[_c('b-skeleton-table',{staticClass:"text-center",attrs:{"columns":4,"rows":10}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }